export default __webpack_public_path__ + "static/test_1_4-50d569a8d802c9050b35313a4b7e215f.png";